import React, { ReactElement } from 'react';
import { makeStyles } from '@mui/styles';
import { Stepper, Step, StepLabel } from '@mui/material';

type StepperProps = {
  steps: { component: ReactElement; label: string }[];
  activeStep: number;
  completedSteps: number[];
  StepIconComponent?: React.FC<any>;
};

const ActiveComponent = ({ steps, activeStep }) => {
  return <>{steps.length ? steps[activeStep].component : null}</>;
};

const LwtStepper: React.FC<StepperProps> = ({
  steps = [],
  activeStep = 1,
  completedSteps = [],
  StepIconComponent
}) => {
  const indexedActiveStep = activeStep - 1 ?? 0;
  const classes = useStyles()();

  const maybeStepIconProps = StepIconComponent && {
    StepIconComponent: StepIconComponent
  };

  return (
    <>
      <Stepper
        activeStep={indexedActiveStep}
        orientation="horizontal"
        connector={<div />}
        className={classes.stepperClass}
      >
        {steps.map((x, idx) => (
          <Step
            active={idx === indexedActiveStep}
            completed={completedSteps.includes(idx + 1)}
            key={idx}
          >
            <StepLabel classes={{ active: classes.activeLabel }} {...maybeStepIconProps}>
              {x.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {/* <Divider /> */}
      <ActiveComponent steps={steps} activeStep={indexedActiveStep} />
    </>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    stepperClass: {
      backgroundColor: 'white',
      display: 'flex',
      justifyContent: 'space-evenly',
      marginBottom: 7,
      padding: 12,
      position: 'sticky',
      zIndex: 2,
      top: 60,
      boxShadow:
        '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
    },
    activeLabel: {
      fontWeight: '600 !important' as any
    }
  }));
export default LwtStepper;
